/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

interface CodeContext {
  couponCode?: string[];
  setCouponCode: (value: string[] | undefined) => void;
  couponDetails?: CouponDetail[];
  setCouponDetails: (value: CouponDetail[] | undefined) => void;
}

export type CouponDetail = {
  code: string;
  type: string;
  value: number;
  applies: string;
  rules: Rules;
  services: string;
  users: string;
  startAt: string;
  expiresAt: string;
  isDisposable: number;
  isActive: number;
  viaResource: string;
  viaResourceId: string;
  viaRelationship: string;
};

type Rules = {
  amount: string;
  route: string;
  from: string;
  to: string;
};

export const CouponContext = createContext<CodeContext>({
  setCouponCode: () => {},
  setCouponDetails: () => {},
});
